import { useState, useEffect } from "react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { Checkbox } from "../../components/ui/checkbox";

import { Link, useNavigate } from "react-router-dom";
import { fetchWalletBalanceService, setLoggedUserDetails } from "../../state/actions/user";
import { useDispatch } from "react-redux";
import { storeAuthData } from "../../services/storage/LocalStorage";
import { ImagePath } from "../../assets/ImagePath";
import { appType } from "../../utils/config/configHelpers";
import { setInializeSocket } from "../../state/actions/socket";
import { updateAppHead } from "../../utils/general";
import { getUserDomainList, setDomainState } from "../../state/actions/domain";
import { setBotWaitLoader } from "../../state/actions/loader";
import { setClearCacheForSpinnetBot } from "../../state/actions/bot";
import { setSessionIdInAxios } from "../../services/userApiServices/axiosInstance";
import authFunctions from "../../services/userApiServices/authFunctions";
import GoogleSignInButton from "../../components/common/GoogleSignUpButton";
import useIsLaptopScreen from "../../utils/customHooks/useIsLaptopScreen";
import LoadingModal from "../../components/ui/Loader/LoadingModal";
import CommonModalPopUp from "../../components/ui/Modals/ModalPopupCommon";
import { FRONTM_AI_DOMAIN, getDomainConfig, isFrontmAiDomain, isOnshipDomain, isPalCareDev2Domain, isSeaDanceDomain, isSeamedixDomain, isStageOnshipDomain, isVikandDomain } from "../../utils/DomainsHelper";
import { UserServiceClientApi } from "../../services/api/UserApiServices";
import { showToast } from "../../components/ui/toaster";


const Login = () => {
  const navigate = useNavigate();
  const [isFocused, setIsFocused] = useState({ email: false, password: false });
  const [userData, setUserData] = useState({ email: "", password: "", });

  const [highlightEmail, setHighlightEmail] = useState(false);
  const [errors, setErrors] = useState({ emailError: "", passwordError: "", });

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [logoImage, setLogoImage] = useState("");
  const [bgImage, setBgImage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const isLaptopScreen = useIsLaptopScreen();

  //handle auth screens according domain
  //=> For onship AppType
  const showAuth = isOnshipDomain || isPalCareDev2Domain

  const dispatch = useDispatch();

  useEffect(() => {
    const rememberMe = localStorage.getItem('rememberMe')
    const userData = JSON.parse(localStorage.getItem('userLoginData'));

    if (rememberMe && userData) {
      setRememberMe(true);
      setUserData({
        email: userData.email,
        password: userData.password,
      });
    }

    const config = getDomainConfig();
    setLogoImage(config.logo);
    setBgImage(config.banner);
    updateAppHead({
      title: config.title,
      favicon: config.favicon,
    });
  }, []);


  const handleChange = (event, type) => {
    const { value } = event.target;
    if (type == "email") {
      setUserData((prevData) => ({ ...prevData, email: value }));
      setErrors((prev) => ({ ...prev, emailError: "" }));
    }
    if (type == "password") {
      setUserData((prevData) => ({ ...prevData, password: value }));
      setErrors((prev) => ({ ...prev, passwordError: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = userData;
    let isValid = true;
    const newErrors = {};

    if (email == "") {
      newErrors.emailError = "Email is required";
      isValid = false;
    }

    if (password == "") {
      newErrors.passwordError = "Password is Invalid. Please try again.";
      isValid = false;
    }

    setErrors(newErrors);
    if (!isValid) return;

    try {
      setIsLoading(true);
      let response = await authFunctions.loginUser(email, password, appType);
      if (response && response.success) {
        setSessionIdInAxios(response.sessionId);
        localStorage.setItem('sessionId', response.sessionId)
        localStorage.setItem('user', JSON.stringify(response?.user))
        storeAuthData(response);
        dispatch(setLoggedUserDetails(response));

        if (rememberMe) {
          localStorage.setItem('rememberMe', rememberMe)
          localStorage.setItem('userLoginData', JSON.stringify(userData));
        } else {
          localStorage.removeItem('rememberMe')
          localStorage.removeItem('userLoginData')
        }

        dispatch(setBotWaitLoader(true));
        dispatch(setInializeSocket(true));
        dispatch(setClearCacheForSpinnetBot(true));

        await getUserDomainList();
        dispatch(setDomainState(true));
        navigate('/app/chats');
        await dispatch(fetchWalletBalanceService())
      } else if (
        response?.message === "Missing required parameter SOFTWARE_TOKEN_MFA_CODE"
        || response?.errorCode === "UserNotConfirmedException"
      ) {
        const params = { email: email, appType: appType };
        try {
          const response = await UserServiceClientApi.resendOtp(params);
          if (response.success) {
            showToast("success", "OTP has been sent to your email successfully. Please verify your email.");
            navigate('/verify', {
              state: {
                email,
                password,
              },
            });
          } else {
            showToast("error", response?.message || "Something went wrong.");
          }
        } catch (error) {
          showToast("error", error.message || "An error occurred.");
        }
      } else {
        if (isSeamedixDomain) {
          setShowModal(true);
        }
        else {
          setErrors({
            emailError: " ",
            passwordError: response.message,
          })
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrors({
        emailError: "",
        passwordError: "Login failed. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };


  const handleGoogleSignIn = async (code) => {
    try {
      const params = {
        code: code,
        platform: "web",
        appType,
      };
      const apiResponse = await authFunctions.doGoogleSignin(params);
      if (apiResponse.success) {
        storeAuthData(apiResponse);
        setSessionIdInAxios(apiResponse.sessionId);
        dispatch(setLoggedUserDetails(apiResponse));

        localStorage.setItem('sessionId', apiResponse.sessionId)
        localStorage.setItem('user', JSON.stringify(apiResponse?.user))

        dispatch(setBotWaitLoader(true));
        dispatch(setInializeSocket(true));
        dispatch(setClearCacheForSpinnetBot(true));

        dispatch(setDomainState(true));
        navigate('/app/chats')
        await dispatch(fetchWalletBalanceService())
      }
      else {
        setErrors({
          emailError: " ",
          passwordError: apiResponse.message,
        })
      }
      console.log("Backend response:", apiResponse);
    } catch (error) {
      console.error("Backend login error:", error);
    }
  };


  useEffect(() => {
    const handleEnterKey = (e) => {
      if (e.key === "Enter") {
        handleSubmit(e);
      }
    };

    window.addEventListener("keydown", handleEnterKey);
    return () => window.removeEventListener("keydown", handleEnterKey);
  }, [userData, rememberMe]);


  return (
    <>
      {/* login page */}
      <section className={"login-sct p-3"}>
        <div className={`auth-section mx-auto`}>
          <div
            className={`grid grid-cols-12 rounded-35 border border-purple-100 items-center overflow-auto cal-h shadow-shd-on mx-auto 
             bg-[#FFFFFF] max-w-auto`}
          >
            {/* welcome form */}
            <div className="sm:col-span-6 col-span-12 3xl:py-[60px] lg:px-[60px] lg:py-[30px] px-[30px] py-[30px] h-full flex flex-col justify-between">
              {
                isPalCareDev2Domain || isSeamedixDomain ? (
                  <>
                    {logoImage && (
                      <img
                        className="mx-auto lg:w-[150px] w-[100px] mb-[3px]"
                        src={logoImage}
                        alt="logo"
                      />
                    )}
                    {ImagePath?.seamedixsLogo && (
                      <img
                        className="mx-auto lg:w-[166px] w-[160px] mb-[35px] mt-[35px]"
                        src={ImagePath.seamedixsLogo}
                        alt="logo"
                      />
                    )}
                  </>
                )
                  :
                  isOnshipDomain ?
                    <img
                      className="mx-auto 3xl:w-[180px] 2xl:w-[180px] lg:w-[120px] w-[140px]"
                      src={logoImage}
                      alt="logo"
                    />
                    :
                    <img
                      style={isSeaDanceDomain ? { marginBottom: '0px' } : { marginBottom: "50px" }}
                      className="mx-auto lg:w-[250px] w-[300px]"
                      src={logoImage}
                      alt="logo"
                    />
              }
              <div>
                <>
                  {
                    showAuth && isLaptopScreen && isSeamedixDomain ?
                      <></>
                      :
                      isPalCareDev2Domain || isSeamedixDomain ?
                        <h1 className="tl-heading !mb-[24px]">Empowering You With<br />Connection. Care. Confidence.</h1>
                        :
                        (isOnshipDomain && isFrontmAiDomain) ?
                          <div className="mb-8">
                            <h1 className="font-semibold text-black text-[24px] text-center mb-1">FrontM Digital Toolbox</h1>
                            <p className="text-black text-[14px] text-center mb-4">One gateway for your maritime apps and data</p>
                          </div>
                          :
                           (isOnshipDomain && isStageOnshipDomain) ?
                            <h1 className="font-semibold text-black text-[30px] text-center mb-8">Welcome!</h1>
                            :
                          isOnshipDomain ?
                          <>
                            <h1 className="font-semibold text-black text-[30px] text-center">The Maritime Superapp</h1>
                            <p className="text-black text-[18px] text-center">Welcome to your maritime community,</p>
                            <p className="text-black text-[18px] text-center mb-4">services and fun, all in one place</p>
                              </>
                            :
                            isVikandDomain ?
                              <h1 className="text-[rgb(102,102,102)] text-[1.3rem] text-center font-normal mb-8">Login to VIKAND Connect</h1>
                              :
                              <>
                                <div className="mb-8">
                                  <h1 className="tl-heading">Welcome!</h1>
                                  <h1 className="text-center text-size-14">Log in to {isSeaDanceDomain ? "Sea-Dance" : "Station Satcom"}</h1>
                                </div>
                              </>
                  }
                </>
                <Card>
                  <div className="space-y-[17px]">
                    <div className="space-y-2 relative">
                      <Label
                        htmlFor="email"
                        labelError={errors.emailError}
                        highlightEmail={highlightEmail}
                        isFocused={isFocused.email}
                      >
                        Email
                      </Label>
                      <Input
                        type="email"
                        inputError={errors.emailError}
                        placeholder="Please enter your email address"
                        onChange={(t) => handleChange(t, "email")}
                        value={userData.email}
                        highlightEmail={highlightEmail}
                        onFocus={() => {
                          setHighlightEmail(false);
                          setIsFocused({ email: true })
                        }}
                        onBlur={() => setIsFocused({ email: false })}
                      />
                      {errors.emailError && (
                        <p className="text-red text-size-10 font-regular">
                          {errors.emailError}
                        </p>
                      )}
                    </div>
                    <div className="space-y-2 relative">
                      <Label
                        htmlFor="email"
                        labelError={errors.passwordError}
                        isFocused={isFocused.password}
                      >
                        Password
                      </Label>
                      <Input
                        type={showPassword ? "text" : "password"}
                        placeholder="Please enter your password"
                        inputError={errors.passwordError}
                        showPassword={showPassword}
                        setShowPassword={setShowPassword}
                        onChange={(t) => handleChange(t, "password")}
                        value={userData.password}
                        onBlur={() => setIsFocused({ password: false })}
                        onFocus={() => {
                          setIsFocused({ password: true })
                          if (userData.email !== "") {
                            setHighlightEmail(true);
                          } else {
                            setHighlightEmail(false);
                          }
                        }}
                      />
                      {errors.passwordError && (
                        <p className="text-red text-size-10 font-regular">
                          {errors.passwordError}.
                        </p>
                      )}
                    </div>
                    {/* Remember me and Forgot password section */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2 cursor-pointer">
                        <Checkbox
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(!rememberMe)}
                        />
                        <span className={`text-dark-3 font-regular ${isOnshipDomain ? "text-size-14" : "text-size-11"}`}>
                          Remember me
                        </span>
                      </div>
                      <Link to="/forgot-password" className="text-[#376AFA] text-size-14 cursor-pointer">Forgot password?</Link>
                    </div>
                    <Button className="text-white" onClick={handleSubmit}>
                      Log In
                    </Button>
                    {showAuth && !isFrontmAiDomain &&
                      <>
                        <div className="flex items-center justify-center gap-3 text-gray-300 text-size-14 mx-5">
                          <span className="bg-devider w-full h-[1px]"></span>
                          or
                          <span className="bg-devider w-full h-[1px]"></span>
                        </div>
                        <GoogleSignInButton handleGoogleSignIn={handleGoogleSignIn} />
                        <p className="text-[#727484] text-size-14 font-medium text-center">
                          You don’t have an account? {" "}
                          <a

                            className="text-[#376AFA] text-size-14 font-semibold cursor-pointer"
                            onClick={() => navigate("/register")}
                          >
                            Sign Up
                          </a>
                        </p>
                      </>
                    }
                  </div>
                </Card>
              </div>
              <img
                className={`mx-auto w-full max-w-[260px] lg:w-[231px] `}
                src={ImagePath?.poweredText}
                alt="logo"
              />
            </div>
            {/* welcome Image */}
            <div
              className="md:col-span-6 hidden md:block w-full h-full"
              style={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
          </div>
        </div>
        {showModal && (
          <CommonModalPopUp
            size="sm"
            noHeader={false}
            hideCrosIcon={false}
            onClose={() => setShowModal(false)}
          >
            {/* Custom header: only the title, centered */}
            <div className="flex justify-center px-6 pt-4 text-red">
              <h2 className="text-lg font-semibold text-gray-900">
                Invalid Credentials
              </h2>
            </div>

            {/* Body */}
            <div className="p-6 space-y-6 text-center">
              <p className="text-[15px] text-[#4f5b7d] leading-relaxed">
                The login credentials you entered are invalid. Please check your username and password and try again.
              </p>

              <div className="rounded-2xl border border-gray-200 bg-blue-50 shadow-sm p-6">
                <p className="text-base font-semibold text-blue-900 mb-3">
                  For immediate medical emergencies at sea, use the contact information below:
                </p>
                <p className="text-blue-800">
                  <span className="font-bold">Phone:</span> +44 (23) 8212 8300
                </p>
                <p className="text-sm text-blue-700">(24-hour maritime medical helpline)</p>
                <p className="text-blue-800 mt-2">
                  <span className="font-bold">Email:</span> emergency@hanseatic-maritime-health.com
                </p>
              </div>
            </div>
          </CommonModalPopUp>
        )}
      </section>
      {/* modal */}
      {isLoading && <LoadingModal />}
    </>
  );
}
export default Login;
